import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";
import AlarmTagsPagedResponse from "@/types/sv-data/alarms/AlarmTagsPagedResponse";
import { EventAlarmTagRequest } from "@/types/sv-data/tags/EventAlarmTag";
import { EventAlarmTagPagedResponse } from "@/types/sv-data/tags/EventAlarmTagPagedResponse";
import { AxiosInstance } from "axios";

class EventsApi {
	private axios: AxiosInstance;
	private axiosJson: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async getAlarmTagsForEvent(eventId: number, paginatedSearchRequest?: PaginatedSearchRequest): Promise<EventAlarmTagPagedResponse> {
		const { data } = await this.axios.get(`/Event/AlarmTagsForEvent/${eventId}`, paginatedSearchRequest);
		return data;
	}

	public async getEventAlarmTagsForArea(paginatedSearchRequest?: PaginatedSearchRequest): Promise<AlarmTagsPagedResponse> {
		const { data } = await this.axios.get(`/Event/EventAlarmTagsForArea`, paginatedSearchRequest);
		return data;
	}

	public async removeEventAlarmTag(request: EventAlarmTagRequest): Promise<void> {
		await this.axiosJson.put(`/Event/RemoveEventAlarmTag`, request);
	}

	public async addEventAlarmTag(request: EventAlarmTagRequest): Promise<void> {
		await this.axiosJson.post(`/Event/AddEventAlarmTag`, request);
	}
}

const eventsApi = new EventsApi();
export default eventsApi;
